import { FC, useEffect } from 'react';
import { CookieBanner } from './CookieBanner';
import { CookieModal } from './CookieModal';
import { useCookieManager } from './useCookieManager';

declare global {
  interface Window {
    openCookieSettings?: () => void;
  }
}

/**
 * Main Cookie Consent orchestrator.
 * Always renders the modal and registers the global function
 * so it can be opened from the footer at any time.
 */
export const CookieConsent: FC = () => {
  const {
    consent,
    isModalOpen,
    acceptAll,
    rejectAll,
    savePreferences,
    openSettings,
    closeSettings,
  } = useCookieManager();

  useEffect(() => {
    window.openCookieSettings = openSettings;
    return () => {
      delete window.openCookieSettings;
    };
  }, [openSettings]);

  return (
    <>
      {!consent && (
        <CookieBanner onAccept={acceptAll} onReject={rejectAll} onSettings={openSettings} />
      )}
      <CookieModal
        isOpen={isModalOpen}
        onClose={closeSettings}
        onSave={savePreferences}
        onReject={rejectAll}
        onAccept={acceptAll}
        currentConsent={consent}
      />
    </>
  );
};

export default CookieConsent;
